import Vue from 'vue';
import Vuex from 'vuex';

import api from "@/api/onlineapps";
// import i18n from "@/languages";
import { cloneDeep } from "lodash";

Vue.use(Vuex)

const getDefaultState = () => {
    return {
      currentUser: '',
      footerText: '©2022, DaLand CUSO',
      stateOptions: [
        { 
            text: 'Select your State', 
            value: ''
        },
        {
            "text": "Alabama",
            "value": "AL"
        },
        {
            "text": "Alaska",
            "value": "AK"
        },    
        {
            "text": "Arizona",
            "value": "AZ"
        },
        {
            "text": "Arkansas",
            "value": "AR"
        },
        {
            "text": "California",
            "value": "CA"
        },
        {
            "text": "Colorado",
            "value": "CO"
        },
        {
            "text": "Connecticut",
            "value": "CT"
        },
        {
            "text": "Delaware",
            "value": "DE"
        },
        {
            "text": "District Of Columbia",
            "value": "DC"
        },    
        {
            "text": "Florida",
            "value": "FL"
        },
        {
            "text": "Georgia",
            "value": "GA"
        },
        {
            "text": "Guam",
            "value": "GU"
        },
        {
            "text": "Hawaii",
            "value": "HI"
        },
        {
            "text": "Idaho",
            "value": "ID"
        },
        {
            "text": "Illinois",
            "value": "IL"
        },
        {
            "text": "Indiana",
            "value": "IN"
        },
        {
            "text": "Iowa",
            "value": "IA"
        },
        {
            "text": "Kansas",
            "value": "KS"
        },
        {
            "text": "Kentucky",
            "value": "KY"
        },
        {
            "text": "Louisiana",
            "value": "LA"
        },
        {
            "text": "Maine",
            "value": "ME"
        },    
        {
            "text": "Maryland",
            "value": "MD"
        },
        {
            "text": "Massachusetts",
            "value": "MA"
        },
        {
            "text": "Michigan",
            "value": "MI"
        },
        {
            "text": "Minnesota",
            "value": "MN"
        },
        {
            "text": "Mississippi",
            "value": "MS"
        },
        {
            "text": "Missouri",
            "value": "MO"
        },
        {
            "text": "Montana",
            "value": "MT"
        },
        {
            "text": "Nebraska",
            "value": "NE"
        },
        {
            "text": "Nevada",
            "value": "NV"
        },
        {
            "text": "New Hampshire",
            "value": "NH"
        },
        {
            "text": "New Jersey",
            "value": "NJ"
        },
        {
            "text": "New Mexico",
            "value": "NM"
        },
        {
            "text": "New York",
            "value": "NY"
        },
        {
            "text": "North Carolina",
            "value": "NC"
        },
        {
            "text": "North Dakota",
            "value": "ND"
        },    
        {
            "text": "Ohio",
            "value": "OH"
        },
        {
            "text": "Oklahoma",
            "value": "OK"
        },
        {
            "text": "Oregon",
            "value": "OR"
        },
        {
            "text": "Palau",
            "value": "PW"
        },
        {
            "text": "Pennsylvania",
            "value": "PA"
        },
        {
            "text": "Puerto Rico",
            "value": "PR"
        },
        {
            "text": "Rhode Island",
            "value": "RI"
        },
        {
            "text": "South Carolina",
            "value": "SC"
        },
        {
            "text": "South Dakota",
            "value": "SD"
        },
        {
            "text": "Tennessee",
            "value": "TN"
        },
        {
            "text": "Texas",
            "value": "TX"
        },
        {
            "text": "Utah",
            "value": "UT"
        },
        {
            "text": "Vermont",
            "value": "VT"
        },
        {
            "text": "Virgin Islands",
            "value": "VI"
        },
        {
            "text": "Virginia",
            "value": "VA"
        },
        {
            "text": "Washington",
            "value": "WA"
        },
        {
            "text": "West Virginia",
            "value": "WV"
        },
        {
            "text": "Wisconsin",
            "value": "WI"
        },
        {
            "text": "Wyoming",
            "value": "WY"
        }
      ],
      creditUnion: {
        name: '',
        phoneNumber: '',
        emailAddress: '',
      },
      eligibilityRequirementsUrl: '#',
      disclosureAsHtml: '',
      loanCategoryId: '',
      loanTypeId: '',
      loanType: '',
      purposeId: '',
      purpose: '',
      loanTermId: '',    
      loanTerm: null,
      maxLoanAmount: 0.00,
      minLoanAmount: 0.00,
      loanRate: null,
      loanFee: null,
      minimumAddressHistoryMonths: 0,
      minimumEmploymentHistoryMonths: 0,
      employmentEligibility: false,
      schoolEligibility: false,
      worshipEligibility: false,
      volunteerEligibility: false,
      donationEligibility: false,
      donationFoundation: '',
      donationFoundationUrl: '#',
      donationAmount: 0.00,
      segEligibility: false,
      familyEligibilityAllowed : false,
      primaryReferenceCount: 0,
      jointReferenceCount: 0,
      requireIDBackImage: true,
      requireIDFrontImage: true,
      approvedMsg: '',
      pendingMsg: '',
      deniedMsg: '',
      loanAmount: null,
      isJointApplication: null,    
      vehicleCollateral: {
        isNew: null,
        vehicleType: '',
        make: '',
        model: '',
        mileage: null,
        year: '',      
        type: {
          typeId: '',
        },
        vin: '',
        seller: '',
      },
      primaryApplicant: {
        firstName: '',
        lastName: '',
        dateOfBirth: null,      
        taxId: null,          
        isEmployed: false,
        isStudent: false,
        attendsWorship: false,
        isVolunteer: false,
        familyEligibility: false,
        isDonating: false,
        preferredMethodOfContact: null,
        challengedQuestionsAnswered: false,
        challengeId: '',
        challengeScore: '',
      },
      primaryPhone: {
        phoneNumber: '',
        phoneType: 'Personal Cell',
        phoneTypeText: 'Cell',
      },
      primaryEmail: {
        emailAddress: '',
        emailType: 'Personal Email',
        emailTypeText: 'Personal',
      },
      primaryIdentification: {
        category: '',
        identificationNumber: '',
        issueDate: null,
        expirationDate: null,
        issuer: '',
        image: '',
        backImage: '',
        imageFormat: ''
      },
      primaryAddress: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zipCode: '',
        monthsAtAddress: '',
        yearsAtAddress: '',
        monthlyPayment: null,
        housingType: '',
        homeValue: null,
      },
      primaryPreviousAddress: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zipCode: '',
        monthsAtAddress: '',
        yearsAtAddress: '',
      },
      primaryPreviousAddresses: [],
      primaryMailingAddress: {
        separateMailingAddress: false,
        address1: '',
        address2: '',
        city: '',
        state: '',
        zipCode: '',
      },
      primaryEmployment: {
        address1: '',
        address2: '',
        city: '',
        employerId: '',
        employerName: '',
        employmentStartDate: null,
        jobTitle: '',
        monthlyIncome: null,
        state: '',
        zipCode: '',
        employmentType: '',
      },
      primaryPreviousEmployment: {
        address1: '',
        address2: '',
        city: '',
        employerId: '',
        employerName: '',
        employmentStartDate: null,
        employmentEndDate: null,
        jobTitle: '',
        monthlyIncome: null,
        state: '',
        zipCode: '',
        employmentType: '',
      },
      primaryPreviousEmployments: [],
      primaryAdditionalIncome: null,
      primaryAdditionalIncomeSource: {
        income: '',
        amount: 0.00,
        description: '',
      },
      primaryAdditionalIncomeSources: [],
      primarySchool: {
        schoolName: '',
        zipCode: '',
      },
      primaryPlaceOfWorship: {
        zipCode: ''
      },
      primaryFamilyMember: {
        name: '',
        relationship: '',
      },
      primaryDonationToFoundation: 0.00,
      primaryPlaceOfVolunter: {
        zipCode: ''
      },
      primaryReference: {
        firstName: '',
        lastName: '',
        address: {
          address1: '',
          address2: '',
          city: '',
          state: '',
          zipCode: '',
        },
        phoneNumber: '',
        phoneType: 'Personal Cell',
        phoneTypeText: 'Cell',
        relationship: '',
        relationshipDuration: null,
      },
      primaryReferences: [],
      jointApplicant: {
        firstName: '',
        lastName: '',
        dateOfBirth: null,      
        taxId: null,
        isEmployed: false,
        isStudent: false,
        attendsWorship: false,
        isVolunteer: false,
        familyEligibility: false,
        isDonating: false,
        preferredMethodOfContact: null,
        challengedQuestionsAnswered: false,
        challengeId: '',
        challengeScore: '',
      },
      jointPhone: {
        phoneNumber: '',
        phoneType: 'Personal Cell',
        phoneTypeText: 'Cell',
      },
      jointEmail: {
        emailAddress: '',
        emailType: 'Personal Email',
        emailTypeText: 'Personal',
      },
      jointIdentification: {
        category: '',
        identificationNumber: '',
        issueDate: null,
        expirationDate: null,
        issuer: '',
        image: '',
        backImage: '',
        imageFormat: ''
      },    
      jointAddress: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zipCode: '',
        monthsAtAddress: '',
        yearsAtAddress: '',
        monthlyPayment: null,
        housingType: '',
        homeValue: null,
      },
      jointPreviousAddress: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zipCode: '',
        monthsAtAddress: '',
        yearsAtAddress: '',
      },
      jointPreviousAddresses: [],
      jointMailingAddress: {
        separateMailingAddress: false,
        address1: '',
        address2: '',
        city: '',
        state: '',
        zipCode: '',
      },
      jointEmployment: {
        address1: '',
        address2: '',
        city: '',
        employerId: '',
        employerName: '',
        employmentStartDate: null,
        jobTitle: '',
        monthlyIncome: null,
        state: '',
        zipCode: '',
        employmentType: '',
      },
      jointPreviousEmployment: {
        address1: '',
        address2: '',
        city: '',
        employerId: '',
        employerName: '',
        employmentStartDate: null,
        employmentEndDate: null,
        jobTitle: '',
        monthlyIncome: null,
        state: '',
        zipCode: '',
        employmentType: '',
      },
      jointPreviousEmployments: [],
      jointAdditionalIncome: null,
      jointAdditionalIncomeSource: {
        income: '',
        amount: 0.00,
        description: '',
      },
      jointAdditionalIncomeSources: [],
      jointSchool: {
        schoolName: '',
        zipCode: '',
      },
      jointPlaceOfWorship: {
        zipCode: ''
      },
      jointPlaceOfVolunter: {
        zipCode: ''
      },
      jointFamilyMember: {
        name: '',
        relationship: '',
      },
      jointDonationToFoundation: 0.00,
      jointReference: {
        firstName: '',
        lastName: '',
        address: {
          address1: '',
          address2: '',
          city: '',
          state: '',
          zipCode: '',
        },
        phoneNumber: '',
        phoneType: 'Personal Cell',
        phoneTypeText: 'Cell',
        relationship: '',
        relationshipDuration: null,
      },
      jointReferences: [],
      parsingIdentification: false,
      segCompanies: [],
      retrievingSegCompanies: false,
      editMode: false,
      appSubmitted: false,
      appStatus: '',
      portalContent: {
        pageName: '',
        contentName: '',
        content: ''
      },
      applicantEligibilityRequirement: '',
      applicationEligibilityRequirement: '',
      primaryEligibilityId: '',
      jointEligibilityId: '',
      ipCheckRequired: false,
      ipDistanceCheckRequired: false,
      blockListCheckRequired: false,
      addressStateCheckRequired: false,
      donationSelectedId: '',

      currentState: {},
      promoCode: '',
      accountCategories: [],
      accountsToOpen: [],
      services: new Map(),
      serviceIds: [],
      debitCard: {
        branch: '',
        deliveryMethod: '',
      },
      courtesyPay: null,
      overdraftTransferDesignation: null,
      maturity: null,
      fundingOption: {
        display: '',
        fundsType: '',
        cardName: '',
        cardExpirationMonth: '',
        cardExpirationYear: '',
        cardNumber: '',
        cardCSC: '',
        accountNumber: '',
        routingNumber: '',
        paymentToken: '',
        accountType: '',
        transferCoreId: '',
        address1: '',
        city: '',
        state: '',
        zipCode: '',
        availableBalance: '',
      },
      preventSubmission: 'Prevent_Submission',
      preventAutoApproval: 'Prevent_Autoapproval',
      ignoreAndAddNote: 'Ignore_AddNote',
      editedIdentificationInfo: false,
      editedContactInfo: false,
      challengeQuestionsEnabled: false,
      challengeQuestionsRequired: false,
      challengeQuestionsRetryAttempts: false,
      identityVerification: {
        tin: '',
        firstName: '',
        lastName: '',
        street: '',
        city: '',
        state: '',
        zipCode: '',
        phoneNumber: '',
        email: '',
        birthDate: '',
        token: '',
        sessionId: '',
        passcode: '',
        verifyType: '',
        baseUrl: '',
        redirectUrl: '',
        transactionKey: '',
      },
  }
}
export default new Vuex.Store({
  state: getDefaultState,
  getters: {  
    isAuthenticated: state => {
      if(state.currentUser && state.currentUser.coreUserId) {
        return true;
      } else {
        return false;
      }
    },
    isNewOrUsedVehicle: state => {
      if(state.vehicleCollateral.isNew != null) {
        return state.vehicleCollateral.isNew;
      }
    },
    primaryAddressHistoryInMonths: state => {
      var primaryAddress = state.primaryAddress;
      var primaryPreviousAddresses = state.primaryPreviousAddresses;
      var addressHistoryInMonths = Number(primaryAddress.monthsAtAddress) + (Number(primaryAddress.yearsAtAddress) * 12);
      if(primaryPreviousAddresses) {
        for(var i = 0; i < primaryPreviousAddresses.length; i++) {
          let previousAddress = primaryPreviousAddresses[i];
          addressHistoryInMonths += Number(previousAddress.monthsAtAddress) + (Number(previousAddress.yearsAtAddress) * 12);
        }
      }
      return addressHistoryInMonths;
    },
    primaryEmploymentHistoryInMonths: state => { // todo use helper to avoid duplicate code
      var primaryEmployment = state.primaryEmployment;
      if(primaryEmployment && primaryEmployment.employmentStartDate) {
        var employmentHistoryInMonths;
        var today = new Date();
        var employmentStartDate = primaryEmployment.employmentStartDate;
        employmentHistoryInMonths = (today.getFullYear() - employmentStartDate.getFullYear()) * 12;
        employmentHistoryInMonths -= employmentStartDate.getMonth();
        employmentHistoryInMonths += today.getMonth();
        employmentHistoryInMonths = employmentHistoryInMonths <= 0 ? 0 : employmentHistoryInMonths;
        var primaryPreviousEmployments = state.primaryPreviousEmployments;
        if(primaryPreviousEmployments) {
          for(var i = 0; i < primaryPreviousEmployments.length; i++) {
            let previousEmployment = primaryPreviousEmployments[i];
            if(previousEmployment && previousEmployment.employmentStartDate) {
              var previousEmploymentEndDate = new Date();
              var previousEmploymentStartDate = previousEmployment.employmentStartDate;
              employmentHistoryInMonths += (previousEmploymentEndDate.getFullYear() - previousEmploymentStartDate.getFullYear()) * 12;
              employmentHistoryInMonths -= previousEmploymentStartDate.getMonth();
              employmentHistoryInMonths += previousEmploymentEndDate.getMonth();
              employmentHistoryInMonths = employmentHistoryInMonths <= 0 ? 0 : employmentHistoryInMonths;
            }
          }
        }
        return employmentHistoryInMonths;
      }
      return 0;
    },
    primaryReferenceRequired: state => {
      return state.primaryReferenceCount > 0;
    },
    jointAddressHistoryInMonths: state => {
      var jointAddress = state.jointAddress;
      var jointPreviousAddresses = state.jointPreviousAddresses;
      var addressHistoryInMonths = Number(jointAddress.monthsAtAddress) + (Number(jointAddress.yearsAtAddress) * 12);
      if(jointPreviousAddresses) {
        for(var i = 0; i < jointPreviousAddresses.length; i++) {
          let previousAddress = jointPreviousAddresses[i];
          addressHistoryInMonths += Number(previousAddress.monthsAtAddress) + (Number(previousAddress.yearsAtAddress) * 12);
        }
      }
      return addressHistoryInMonths;
    },
    jointEmploymentHistoryInMonths: state => { // todo use helper to avoid duplicate code
      var jointEmployment = state.jointEmployment;
      if(jointEmployment && jointEmployment.employmentStartDate) {
        var employmentHistoryInMonths;
        var today = new Date();
        var employmentStartDate = jointEmployment.employmentStartDate;
        employmentHistoryInMonths = (today.getFullYear() -  employmentStartDate.getFullYear()) * 12;
        employmentHistoryInMonths -= employmentStartDate.getMonth();
        employmentHistoryInMonths += today.getMonth();
        employmentHistoryInMonths = employmentHistoryInMonths <= 0 ? 0 : employmentHistoryInMonths;
        var jointPreviousEmployments = state.jointPreviousEmployments;
        if(jointPreviousEmployments) {
          for(var i = 0; i < jointPreviousEmployments.length; i++) {
            let previousEmployment = jointPreviousEmployments[i];
            if(previousEmployment && previousEmployment.employmentStartDate) {
              var previousEmploymentEndDate = new Date();
              var previousEmploymentStartDate = previousEmployment.employmentStartDate;
              employmentHistoryInMonths += (previousEmploymentEndDate.getFullYear() -  previousEmploymentStartDate.getFullYear()) * 12;
              employmentHistoryInMonths -= previousEmploymentStartDate.getMonth();
              employmentHistoryInMonths += previousEmploymentEndDate.getMonth();
              employmentHistoryInMonths = employmentHistoryInMonths <= 0 ? 0 : employmentHistoryInMonths;
            }
          }
        }
        return employmentHistoryInMonths;
      }
      return 0;
    },
    jointReferenceRequired: state => {
      return state.jointReferenceCount > 0;
    },
    getPageContent: (state) => (pageName) => {
      var content = state.portalContent.filter(content => content.pageName === pageName);
      if(content) {
        return content;
      }
      return [];
    },
    primaryAddresses: (state) => {
      var primaryAddresses = [state.primaryAddress];
      if(state.primaryPreviousAddresses.length > 0) {
        primaryAddresses = primaryAddresses.concat(state.primaryPreviousAddresses);
      }
      return primaryAddresses;
    },
    primaryEmployments: (state) => {
      var primaryEmployments = [state.primaryEmployment];
      if(state.primaryPreviousEmployments.length > 0) {
        primaryEmployments = primaryEmployments.concat(state.primaryPreviousEmployments);
      }  
      return primaryEmployments;
    },
    jointAddresses: (state) => {
      var jointAddresses = [state.jointAddress];
      if(state.jointPreviousAddresses.length > 0) {
        jointAddresses = jointAddresses.concat(state.jointPreviousAddresses);
      }
      return jointAddresses;
    },
    jointEmployments: (state) => {
      var jointEmployments = [state.jointEmployment];
      if(state.jointPreviousEmployments.length > 0) {
        jointEmployments = jointEmployments.concat(state.jointPreviousEmployments);
      }  
      return jointEmployments;
    },
    shareTypeIds: (state) => {
      var shareTypeIds = [];
      for(let i = 0; i < state.accountsToOpen.length; i++) {
        shareTypeIds.push(state.accountsToOpen[i].coreId);
      }
      return shareTypeIds;
    },
    fundAmount: (state) => {
      var fundAmount = 0.00;
      for(let i = 0; i < state.accountsToOpen.length; i++) {
        if(state.accountsToOpen[i].required) {
          fundAmount += state.accountsToOpen[i].minOpenAmount;
        }
      }
      return fundAmount;
    },
    selectedServices: (state) => {
      var services = [];
      state.services.forEach(function(value, key) {
        var serviceId = key;
        if((serviceId === 'DEB' && state.debitCard.deliveryMethod === "MAIL")
          || (serviceId === 'CPY' && state.courtesyPay)
          || (serviceId === 'OTD' && state.overdraftTransferDesignation)
          || (serviceId === 'CDM' && state.maturity)) {
          services.push(serviceId);
        }
      });
      return services;
    },
  },
  mutations: {
    resetState (state) {
      // Merge rather than replace so we don't lose observers
      // https://github.com/vuejs/vuex/issues/1118
      Object.assign(state, getDefaultState());
    },
    updateCreditUnion(state, val) {
      state.creditUnion.name = val.name;
      state.creditUnion.phoneNumber = val.phoneNumber;
      state.creditUnion.emailAddress = val.emailAddress;
    },
    updateEligibilityRequirementsUrl(state, val) {
      state.eligibilityRequirementsUrl = val.eligibilityRequirementsUrl;
    },
    updateDisclosure(state, val) {
      state.disclosureAsHtml = val.disclosureAsHtml;
    },
    updatePortalContent(state, val) {
      state.portalContent = val.portalContent;
    },
    updateLoanCategory(state, val) {
      state.loanCategoryId = val.loanCategoryId;
    },
    updateLoanType(state, val) {
      state.loanTypeId = val.loanTypeId;
      state.loanType = val.loanType;
    },
    updateLoanPurpose(state, val) {
      state.purposeId = val.purposeId;
      state.purpose = val.purpose;
    }, 
    updateMinAddressHistoryMonths(state, val) {
      state.minimumAddressHistoryMonths = val.minimumAddressHistoryMonths;
    },
    updateMinEmploymentHistoryMonths(state, val) {
      state.minimumEmploymentHistoryMonths = val.minimumEmploymentHistoryMonths;
    },
    updatePrimaryReferenceCount(state, val) {
      state.primaryReferenceCount = val.primaryReferenceCount;
    },
    updateJointReferenceCount(state, val) {
      state.jointReferenceCount = val.jointReferenceCount;
    },
    updateEmploymentEligibility(state, val) {
      state.employmentEligibility = val.employmentEligibility;
    },
    updateSchoolEligibility(state, val) {
      state.schoolEligibility = val.schoolEligibility;
    },
    updateWorshipEligibility(state, val) {
      state.worshipEligibility = val.worshipEligibility;
    },
    updateVolunteerEligibility(state, val) {
      state.volunteerEligibility = val.volunteerEligibility;
    },
    updateDonationEligibility(state, val) {
      state.donationEligibility = val.donationEligibility;
    },
    updateDonationFoundation(state, val) {
      state.donationFoundation = val.donationFoundation;
    },
    updateDonationFoundationUrl(state, val) {
      state.donationFoundationUrl = val;
    },
    updateDonationAmount(state, val) {
      state.donationAmount = val.donationAmount;
    },
    updateSegEligibility(state, val) {
      state.segEligibility = val.segEligibility;
    },
    updateFamilyEligibilityAllowed (state, val) {
      state.familyEligibilityAllowed  = val;
    },
    updateRequireIDBackImage(state, val) {
      state.requireIDBackImage = val;
    },
    updateRequireIDFrontImage(state, val) {
      state.requireIDFrontImage = val;
    },
    updateLoanTerm(state, val) {
      var term = val.term;
      state.loanTermId = term.coreId;
      state.loanTerm = term.loanTermInMonths;
      state.maxLoanAmount = term.maximumAmount;
      state.minLoanAmount = term.minimumAmount;
      state.loanRate = term.loanRate;
      state.loanFee = term.loanFee;
    },
    updateLoanAmount(state, val) {
      state.loanAmount = val.loanAmount;
    },
    updateIsJointApplication(state, val) {
      state.isJointApplication = val;
    },    
    updatePromoCode(state, val) {
      state.promoCode = val.promoCode;
    },
    updateVehicleMake(state, val) {
      state.vehicleCollateral.make = val.make;
    },
    updateVehicleModel(state, val) {
      state.vehicleCollateral.model = val.model;
    },
    updateVehicleYear(state, val) {
      state.vehicleCollateral.year = val.year;
    },
    updateVehicleMileage(state, val) {
      state.vehicleCollateral.mileage = val.mileage;
    },
    updateVehicleVin(state, val) {
      state.vehicleCollateral.vin = val.vin;
    },
    updateVehicleSeller(state, val) {
      state.vehicleCollateral.seller = val.seller;
    },
    updateVehicleType(state, val) {
      state.vehicleCollateral.vehicleType = val.vehicleType;
    },
    updateApplicantFromIdParse(state, val) {      
      if(val.isPrimary) {
        state.primaryIdentification.identificationNumber = val.idData.idNumber;
        state.primaryIdentification.issuer = val.idData.issuer;
        if(val.idData.expirationDate) {
          state.primaryIdentification.expirationDate = new Date(val.idData.expirationDate);          
        }
        if(val.idData.issueDate) {
          state.primaryIdentification.issueDate = new Date(val.idData.issueDate);        
        }        

        state.primaryApplicant.firstName = val.idData.firstName;
        state.primaryApplicant.lastName = val.idData.lastName;
        if(val.idData.dateOfBirth) {
          state.primaryApplicant.dateOfBirth = new Date(val.idData.dateOfBirth);
        }

        state.primaryAddress.address1 = val.idData.address1;
        state.primaryAddress.address2 = val.idData.address2;
        state.primaryAddress.city = val.idData.city;
        state.primaryAddress.state = val.idData.state;
        state.primaryAddress.zipCode = val.idData.zipCode;
      } else {
        state.jointIdentification.identificationNumber = val.idData.idNumber;
        state.jointIdentification.identificationNumber = val.idData.idNumber;
        state.jointIdentification.issuer = val.idData.issuer;
        if(val.idData.expirationDate) {
          state.jointIdentification.expirationDate = new Date(val.idData.expirationDate);          
        }
        if(val.idData.issueDate) {
          state.jointIdentification.issueDate = new Date(val.idData.issueDate);        
        }        

        state.jointApplicant.firstName = val.idData.firstName;
        state.jointApplicant.lastName = val.idData.lastName;
        if(val.idData.dateOfBirth) {
          state.jointApplicant.dateOfBirth = new Date(val.idData.dateOfBirth);
        }

        state.jointAddress.address1 = val.idData.address1;
        state.jointAddress.address2 = val.idData.address2;
        state.jointAddress.city = val.idData.city;
        state.jointAddress.state = val.idData.state;
        state.jointAddress.zipCode = val.idData.zipCode;
      }
    },
    updatePhoneType(state, val) {
      if (val.isPrimary) {
        state.primaryApplicant.phoneType = val.phoneType;
      } else {
        state.jointApplicant.phoneType = val.phoneType;
      }
    },
    updatePhoneTypeText(state, val) {
      if(val.isPrimary) {
        state.primaryPhone.phoneTypeText = val.phoneTypeText
      } else {
        state.jointPhone.phoneTypeText = val.phoneTypeText
      }
    },
    updateApplicantPhone(state, val) {
      if(val.isPrimary) {
        state.primaryPhone.phoneNumber = val.phoneNumber
      } else {
        state.jointPhone.phoneNumber = val.phoneNumber
      }
    },
    updateEmailType(state, val) {
      if (val.isPrimary) {
        state.primaryEmail.emailType = val.emailType;
      } else {
        state.jointEmail.emailType = val.emailType;
      }
    },
    updateEmailTypeText(state, val) {
      if(val.isPrimary) {
        state.primaryEmail.emailTypeText = val.emailTypeText
      } else {
        state.jointEmail.emailTypeText = val.emailTypeText
      }
    },
    updateApplicantEmail(state, val) {
      if(val.isPrimary) {
        state.primaryEmail.emailAddress = val.emailAddress;
      } else {
        state.jointEmail.emailAddress = val.emailAddress;
      }
    },
    updatePreferredMethodOfContact(state, val) {
      if (val.isPrimary) {
        state.primaryApplicant.preferredMethodOfContact = val.preferredMethodOfContact
      } else {
        state.jointApplicant.preferredMethodOfContact = val.preferredMethodOfContact
      }
    },
    updateIdentificationNumber(state, val) {
      if(val.isPrimary) {
        state.primaryIdentification.identificationNumber = val.identificationNumber;
      } else {
        state.jointIdentification.identificationNumber = val.identificationNumber;
      }
    },
    updateIdentificationCategory(state, val) {
      if(val.isPrimary) {
        state.primaryIdentification.category = val.category;
      } else {
        state.jointIdentification.category = val.category;
      }
    },
    updateIdentificationIssueDate(state, val) {
      if(val.isPrimary) {
        state.primaryIdentification.issueDate = val.issueDate;
      } else {
        state.jointIdentification.issueDate = val.issueDate;
      }
    },
    updateIdentificationExpirationDate(state, val) {
      if(val.isPrimary) {
        state.primaryIdentification.expirationDate = val.expirationDate;
      } else {
        state.jointIdentification.expirationDate = val.expirationDate;
      }      
    },
    updateIdentificationIssuer(state, val) {
      if(val.isPrimary) {
        state.primaryIdentification.issuer = val.issuer;
      } else {
        state.jointIdentification.issuer = val.issuer;
      }
    },
    updateIdentificationImageFormat(state, val) {
      if(val.isPrimary) {
        state.primaryIdentification.imageFormat = val.imageFormat;
      } else {
        state.jointIdentification.imageFormat = val.imageFormat;
      }
    },
    updateIdentificationImage(state, val) {
      if(val.isPrimary) {
        state.primaryIdentification.image = val.image;
      } else {
        state.jointIdentification.image = val.image;
      }
    },
    updateIdentificationBackImage(state, val) {
      if(val.isPrimary) {
        state.primaryIdentification.backImage = val.backImage;
      } else {
        state.jointIdentification.backImage = val.backImage;
      }
    },
    updateApplicantFirstName(state, val) {
      if(val.isPrimary) {
        state.primaryApplicant.firstName = val.firstName;
      } else {
        state.jointApplicant.firstName = val.firstName;
      }
    },
    updateApplicantLastName(state, val) {
      if(val.isPrimary) {
        state.primaryApplicant.lastName = val.lastName;
      } else {
        state.jointApplicant.lastName = val.lastName;
      }
    },
    updateApplicantTaxId(state,val) {
        if(val.isPrimary) {
            if(val.taxId !== null) {
                state.primaryApplicant.taxId = val.taxId.replaceAll('-','')
            } else {
                state.primaryApplicant.taxId = null
            }
        } else {
            if(val.taxId !== null) {
                state.jointApplicant.taxId = val.taxId.replaceAll('-','')
            } else {
                state.jointApplicant.taxId = null
            }
        }
    },
    updateApplicantDateOfBirth(state, val) {
      if(val.isPrimary) {
        state.primaryApplicant.dateOfBirth = val.dateOfBirth;
      } else {
        state.jointApplicant.dateOfBirth = val.dateOfBirth;
      }
    },
    updateApplicantAddress1(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentAddress) {
          state.primaryAddress.address1 = val.address1;
        } else {
          state.primaryPreviousAddress.address1 = val.address1;
        }        
      } else {
        if(val.isCurrentAddress) {
          state.jointAddress.address1 = val.address1;
        } else {
          state.jointPreviousAddress.address1 = val.address1;
        }
      }
    },
    updateApplicantAddress2(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentAddress) {
          state.primaryAddress.address2 = val.address2;
        } else {
          state.primaryPreviousAddress.address2 = val.address2;
        }        
      } else {
        if(val.isCurrentAddress) {
          state.jointAddress.address2 = val.address2;
        } else {
          state.jointPreviousAddress.address2 = val.address2;
        }
      }
    },
    updateApplicantCity(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentAddress) {
          state.primaryAddress.city = val.city;
        } else {
          state.primaryPreviousAddress.city = val.city;
        }        
      } else {
        if(val.isCurrentAddress) {
          state.jointAddress.city = val.city;
        } else {
          state.jointPreviousAddress.city = val.city;
        }
      }
    },
    updateApplicantState(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentAddress) {
          state.primaryAddress.state = val.state;
        } else {
          state.primaryPreviousAddress.state = val.state;
        }        
      } else {
        if(val.isCurrentAddress) {
          state.jointAddress.state = val.state;
        } else {
          state.jointPreviousAddress.state = val.state;
        }
      }
    },
    updateApplicantZipCode(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentAddress) {
          state.primaryAddress.zipCode = val.zipCode;
        } else {
          state.primaryPreviousAddress.zipCode = val.zipCode;
        }        
      } else {
        if(val.isCurrentAddress) {
          state.jointAddress.zipCode = val.zipCode;
        } else {
          state.jointPreviousAddress.zipCode = val.zipCode;
        }
      }
    },
    updateMonthsAtAddress(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentAddress) {
          state.primaryAddress.monthsAtAddress = val.monthsAtAddress;
        } else {
          state.primaryPreviousAddress.monthsAtAddress = val.monthsAtAddress;
        }
      } else {
        if(val.isCurrentAddress) {
          state.jointAddress.monthsAtAddress = val.monthsAtAddress;
        } else {
          state.jointPreviousAddress.monthsAtAddress = val.monthsAtAddress;
        }
      }
    },
    updateYearsAtAddress(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentAddress) {
          state.primaryAddress.yearsAtAddress = val.yearsAtAddress;
        } else {
          state.primaryPreviousAddress.yearsAtAddress = val.yearsAtAddress;
        }
      } else {
        if(val.isCurrentAddress) {
          state.jointAddress.yearsAtAddress = val.yearsAtAddress;
        } else {
          state.jointPreviousAddress.yearsAtAddress = val.yearsAtAddress;
        }
      }
    },
    updateApplicantHousingType(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentAddress) {
          state.primaryAddress.housingType = val.housingType;
        } else {
          state.primaryPreviousAddress.housingType = val.housingType;
        }        
      } else {
        if(val.isCurrentAddress) {
          state.jointAddress.housingType = val.housingType;
        } else {
          state.jointPreviousAddress.housingType = val.housingType;
        }
      }
    },
    updateApplicantHomeValue(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentAddress) {
          state.primaryAddress.homeValue = val.homeValue;
        } else {
          state.primaryPreviousAddress.homeValue = val.homeValue;
        }        
      } else {
        if(val.isCurrentAddress) {
          state.jointAddress.homeValue = val.homeValue;
        } else {
          state.jointPreviousAddress.homeValue = val.homeValue;
        }
      }
    },
    updateApplicantMonthlyPayment(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentAddress) {
          state.primaryAddress.monthlyPayment = val.monthlyPayment;
        } else {
          state.primaryPreviousAddress.monthlyPayment = val.monthlyPayment;
        }        
      } else {
        if(val.isCurrentAddress) {
          state.jointAddress.monthlyPayment = val.monthlyPayment;
        } else {
          state.jointPreviousAddress.monthlyPayment = val.monthlyPayment;
        }
      }
    },
    updateApplicantMailingSeparate(state, val) {
      if(val.isPrimary) {
        state.primaryMailingAddress.separateMailingAddress = val.separateMailingAddress;
      } else {
          state.jointMailingAddress.separateMailingAddress = val.separateMailingAddress;
      }
    },
    updateApplicantMailingAddress1(state, val) {
      if(val.isPrimary) {
        state.primaryMailingAddress.address1 = val.address1;
      } else {
          state.jointMailingAddress.address1 = val.address1;
      }
    },
    updateApplicantMailingAddress2(state, val) {
      if(val.isPrimary) {
        state.primaryMailingAddress.address2 = val.address2;
      } else {
          state.jointMailingAddress.address2 = val.address2;
      }
    },
    updateApplicantMailingCity(state, val) {
      if(val.isPrimary) {
        state.primaryMailingAddress.city = val.city;
      } else {
          state.jointMailingAddress.city = val.city;
      }
    },
    updateApplicantMailingState(state, val) {
      if(val.isPrimary) {
        state.primaryMailingAddress.state = val.state;
      } else {
          state.jointMailingAddress.state = val.state;
      }
    },
    updateApplicantMailingZipCode(state, val) {
      if(val.isPrimary) {
        state.primaryMailingAddress.zipCode = val.zipCode;
      } else {
          state.jointMailingAddress.zipCode = val.zipCode;
      }
    },
    updateSegCompanies(state, val) {
      state.segCompanies = val.segCompanies;
    },
    updateApplicantEmploymentStatus(state, val) {
      if(val.isPrimary) {
        state.primaryApplicant.isEmployed = val.isEmployed;
      } else {
        state.jointApplicant.isEmployed = val.isEmployed;
      }
    },
    updateEmploymentType(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentEmployment) {          
          state.primaryEmployment.employmentType = val.employmentType;
        } else {          
          state.primaryPreviousEmployment.employmentType = val.employmentType;
        }        
      } else {
        if(val.isCurrentEmployment) {          
          state.jointEmployment.employmentType = val.employmentType;
        } else {          
          state.jointPreviousEmployment.employmentType = val.employmentType;
        }        
      }
    },
    updateEmployerId(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentEmployment) {
          state.primaryEmployment.employerId = val.employerId;
        } else {
          state.primaryPreviousEmployment.employerId = val.employerId;
        }
      } else {
        if(val.isCurrentEmployment) {
          state.jointEmployment.employerId = val.employerId;
        } else {
          state.jointPreviousEmployment.employerId = val.employerId;
        }        
      }
    },
    updateEmployerName(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentEmployment) {          
          state.primaryEmployment.employerName = val.employerName;  
        } else {          
          state.primaryPreviousEmployment.employerName = val.employerName;  
        }        
      } else {
        if(val.isCurrentEmployment) {          
          state.jointEmployment.employerName = val.employerName;  
        } else {
          state.jointPreviousEmployment.employerName = val.employerName;  
        }        
      }
    },
    updateEmployerAddress1(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentEmployment) {          
          state.primaryEmployment.address1 = val.address1;
        } else {
          state.primaryPreviousEmployment.address1 = val.address1;
        }        
      } else {
        if(val.isCurrentEmployment) {          
          state.jointEmployment.address1 = val.address1;
        } else {
          state.jointPreviousEmployment.address1 = val.address1;
        }
      }
    },
    updateEmployerAddress2(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentEmployment) {          
          state.primaryEmployment.address2 = val.address2;
        } else {
          state.primaryPreviousEmployment.address2 = val.address2;
        }        
      } else {
        if(val.isCurrentEmployment) {          
          state.jointEmployment.address2 = val.address2;
        } else {
          state.jointPreviousEmployment.address2 = val.address2;
        }
      }
    },
    updateEmployerCity(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentEmployment) {          
          state.primaryEmployment.city = val.city;
        } else {
          state.primaryPreviousEmployment.city = val.city;
        }        
      } else {
        if(val.isCurrentEmployment) {          
          state.jointEmployment.city = val.city;
        } else {
          state.jointPreviousEmployment.city = val.city;
        }
      }
    },
    updateEmployerState(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentEmployment) {          
          state.primaryEmployment.state = val.state;
        } else {
          state.primaryPreviousEmployment.state = val.state;
        }        
      } else {
        if(val.isCurrentEmployment) {          
          state.jointEmployment.state = val.state;
        } else {
          state.jointPreviousEmployment.state = val.state;
        }
      }
    },
    updateEmployerZipCode(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentEmployment) {          
          state.primaryEmployment.zipCode = val.zipCode;
        } else {
          state.primaryPreviousEmployment.zipCode = val.zipCode;
        }        
      } else {
        if(val.isCurrentEmployment) {          
          state.jointEmployment.zipCode = val.zipCode;
        } else {
          state.jointPreviousEmployment.zipCode = val.zipCode;
        }
      }
    },
    updateEmployerPhoneNumber(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentEmployment) {          
          state.primaryEmployment.phoneNumber = val.phoneNumber;
        } else {
          state.primaryPreviousEmployment.phoneNumber = val.phoneNumber;
        }        
      } else {
        if(val.isCurrentEmployment) {          
          state.jointEmployment.phoneNumber = val.phoneNumber;
        } else {
          state.jointPreviousEmployment.phoneNumber = val.phoneNumber;
        }
      }
    },
    updateEmploymentJobTitle(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentEmployment) {          
          state.primaryEmployment.jobTitle = val.jobTitle;
        } else {
          state.primaryPreviousEmployment.jobTitle= val.jobTitle;
        }        
      } else {
        if(val.isCurrentEmployment) {          
          state.jointEmployment.jobTitle = val.jobTitle;
        } else {
          state.jointPreviousEmployment.jobTitle = val.jobTitle;
        }
      }
    },
    updateEmploymentStartDate(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentEmployment) {          
          state.primaryEmployment.employmentStartDate = val.startDate;
        } else {
          state.primaryPreviousEmployment.employmentStartDate = val.startDate;
        }        
      } else {
        if(val.isCurrentEmployment) {          
          state.jointEmployment.employmentStartDate = val.startDate;
        } else {
          state.jointPreviousEmployment.employmentStartDate = val.startDate;
        }
      }
    },
    updateEmploymentMonthlyIncome(state, val) {
      if(val.isPrimary) {
        if(val.isCurrentEmployment) {          
          state.primaryEmployment.monthlyIncome = val.monthlyIncome;
        } else {
          state.primaryPreviousEmployment.monthlyIncome = val.monthlyIncome;
        }        
      } else {
        if(val.isCurrentEmployment) {
          
          state.jointEmployment.monthlyIncome = val.monthlyIncome;
        } else {
          state.jointPreviousEmployment.monthlyIncome = val.monthlyIncome;
        }
      }
    },
    updateAdditionalIncome(state, val) {
      if(val.isPrimary) {
        state.primaryAdditionalIncome = val.additionalIncome;
      } else {
        state.jointAdditionalIncome = val.additionalIncome;
      }
    },
    updateApplicantStudentStatus(state, val) {
      if(val.isPrimary) {
        state.primaryApplicant.isStudent = val.isStudent;
      } else {
        state.jointApplicant.isStudent = val.isStudent;
      }
    },
    updateSchoolName(state, val) {
      if(val.isPrimary) {
        state.primarySchool.schoolName = val.schoolName;     
      } else {
        state.jointSchool.schoolName = val.schoolName;        
      }
    },
    updateSchoolZipCode(state, val) {
      if(val.isPrimary) {
        state.primarySchool.zipCode = val.zipCode;     
      } else {
        state.jointSchool.zipCode = val.zipCode;        
      }
    },
    updateApplicantWorshipStatus(state, val) {
      if(val.isPrimary) {
        state.primaryApplicant.attendsWorship = val.attendsWorship;
      } else {
        state.jointApplicant.attendsWorship = val.attendsWorship;
      }
    },
    updatePlaceOfWorshipZipCode(state, val) {
      if(val.isPrimary) {
        state.primaryPlaceOfWorship.zipCode = val.zipCode;     
      } else {
        state.jointPlaceOfWorship.zipCode = val.zipCode;        
      }
    },
    updateApplicantVolunteerStatus(state, val) {
      if(val.isPrimary) {
        state.primaryApplicant.isVolunteer = val.isVolunteer;
      } else {
        state.jointApplicant.isVolunteer = val.isVolunteer;
      }
    },
    updatePlaceOfVolunteerZipCode(state, val) {
      if(val.isPrimary) {
        state.primaryPlaceOfVolunter.zipCode = val.zipCode;     
      } else {
        state.jointPlaceOfVolunter.zipCode = val.zipCode;        
      }
    },
    updateApplicantFamilyEligibility(state, val) {
      if(val.isPrimary) {
        state.primaryApplicant.familyEligibility = val.familyEligibility;
      } else {
        state.jointApplicant.familyEligibility = val.familyEligibility;
      }
    },
    updateFamilyMemberName(state, val) {
      if(val.isPrimary) {
        state.primaryFamilyMember.name = val.name;     
      } else {
        state.jointFamilyMember.name = val.name;        
      }
    },
    updateFamilyMemberRelationship(state, val) {
      if(val.isPrimary) {
        state.primaryFamilyMember.relationship = val.relationship;     
      } else {
        state.jointFamilyMember.relationship = val.relationship;        
      }
    },
    updateApplicantDonationStatus(state, val) {
      if(val.isPrimary) {
        state.primaryApplicant.isDonating = val.isDonating;
        state.donationSelectedId = state.donationEligibility;
      } else {
        state.jointApplicant.isDonating = val.isDonating;
      }
    },
    updateDonationToFoundation(state, val) {
      if(val.isPrimary) {
        state.primaryDonationToFoundation = val.donationToFoundation;     
      } else {
        state.jointDonationToFoundation = val.donationToFoundation;        
      }
    },
    updateProgress(state) {
      //save current vuex state
      let currentState = state;
      state.currentState = cloneDeep(currentState);
    },
    updateEditMode(state, editing) {
      state.editMode = editing;
      if(state.editMode === true) {
        //save current vuex state
        let currentState = state;
        state.currentState = cloneDeep(currentState);
      } else {
        state.currentState = {};
      }
    },
    updateEditedContactInfo(state, val) {
      state.editedContactInfo = val;
    },
    updateEditedIdentificationInfo(state, val) {
      state.editedIdentificationInfo = val;
    },
    updateSubmittedStatus(state, val) {
      state.appSubmitted = val;
    },
    updateAppStatus(state, val) {
      state.appStatus = val;
    },
    setParsingIdentification(state, val) {
      state.parsingIdentification = val;
    },
    setRetrievingSegCompanies(state, val) {
      state.retrievingSegCompanies = val;
    },
    updateEligiblityId(state, val) {
      if(val.isPrimary) {
        state.primaryEligibilityId = val.eligibilityId;     
      } else {
        state.jointEligibilityId = val.eligibilityId;        
      }
    },
    updateApplicantEligibilityRequirement(state, val) {
      state.applicantEligibilityRequirement = val;
    },
    updateApplicationEligibilityRequirement(state, val) {
      state.applicationEligibilityRequirement = val;
    },
    updateIpCheckRequired(state, val) {
      state.ipCheckRequired = val;
    },
    updateIpDistanceCheckRequired(state, val) {
      state.ipDistanceCheckRequired = val;
    },
    updateBlockListCheckRequired(state, val) {
      state.blockListCheckRequired = val;
    },
    updateAddressStateCheckRequired(state, val) {
      state.addressStateCheckRequired = val;
    },
    updateDonationSelectedId(state, val) {
      state.donationSelectedId = val;
    },
    updateGetDebitCard(state, val) {
      if(val) {
        state.debitCard.deliveryMethod = "MAIL";
      } else {
        state.debitCard.deliveryMethod = "";
      }
    },    
    updateOptInCourtesyPay(state, val) {
      state.courtesyPay = val;
    },
    updateOverdraftTransferDesignation(state, val) {
      state.overdraftTransferDesignation = val;
    },
    updateMaturity(state, val) {
      state.maturity = val;
    },
    updateFundingOptionType(state, val) {
      state.fundingOption.fundsType = val;
    },
    updateFundingDisplay(state, val) {
      state.fundingOption.display = val
    },
    updateFundingAccountType(state, val) {
      state.fundingOption.accountType = val;
    },
    updateFundingAccountNumber(state, val) {
      state.fundingOption.accountNumber = val;
    },
    updateFundingRoutingNumber(state, val) {
      state.fundingOption.routingNumber = val;
    },
    updateCheckingOptions(state, val) {
      state.checkingOptions = val;
    },
    updateEligibleCertificates(state, val) {
      state.eligibleCertificates = val;
    },
    updateAccountCategories(state, val) {
      val.forEach(function(category){
        category.eligibleAccountTypes.forEach(function(accountType){
          accountType.selected = false;
        });
      });
      state.accountCategories = val;
    },
    updateChallengeQuestionsEnabled(state, val) {
      state.challengeQuestionsEnabled = val;
    },
    updateChallengeQuestionsRequired(state, val) {
      state.challengeQuestionsRequired = val;
    },
    updateChallengeQuestionsRetryAttempts(state, val) {
      state.challengeQuestionsRetryAttempts = val;
    },
    updateChallengeQuestionsAnswered(state, val) {
      if(val.isPrimary) {
        state.primaryApplicant.challengedQuestionsAnswered = val.challengedQuestionsAnswered;
      } else {
        state.jointApplicant.challengedQuestionsAnswered = val.challengedQuestionsAnswered;
      }
    },
    updateApplicantChallengeScore(state, val) {
      if(val.isPrimary) {        
        state.primaryApplicant.challengeScore = val.score;         
      } else {        
        state.jointApplicant.challengeScore = val.score;        
      }
    },
    updateApplicantChallengeId(state, val) {
      if(val.isPrimary) {        
        state.primaryApplicant.challengeId = val.challengeId;         
      } else {        
        state.jointApplicant.challengeId = val.challengeId;        
      }
    },
    updateIdvTaxId(state, val) {
      state.identityVerification.tin = val
    },
    updateIdvPhone(state, val) {
      state.identityVerification.phoneNumber = val
    },
    updateIdvZip(state, val) {
      state.identityVerification.zipCode = val
    },
    updateIdvPasscode(state, val) {
      state.identityVerification.passcode = val
    },
    updateIdvSessionId(state, val) {
      state.identityVerification.sessionId = val
    },
    updateIdvToken(state, val) {
      state.identityVerification.token = val
    },
    updateIdvTransactionKey(state, val) {
      state.identityVerification.transactionKey = val
    },
  },
  actions: {
    async getAppConfig (context) {
      let response = await api.getAppConfig();

      if(response.success) {
        var appConfig = response.configuration;
        context.commit('updateCreditUnion', { name: appConfig.creditUnionName, phoneNumber: appConfig.creditUnionPhone, emailAddress: appConfig.creditUnionEmail });
        context.commit('updateEligibilityRequirementsUrl', { eligibilityRequirementsUrl: appConfig.eligibilityRequirementsUrl });
        context.commit('updateMinAddressHistoryMonths', { minimumAddressHistoryMonths: appConfig.minimumAddressHistoryMonths });
        context.commit('updateMinEmploymentHistoryMonths', { minimumEmploymentHistoryMonths: appConfig.minimumEmploymentHistoryMonths });
        context.commit('updateEmploymentEligibility', { employmentEligibility: appConfig.employmentEligibility });
        context.commit('updateSchoolEligibility', { schoolEligibility: appConfig.schoolEligibility });
        context.commit('updateWorshipEligibility', { worshipEligibility: appConfig.worshipEligibility });
        context.commit('updateVolunteerEligibility', { volunteerEligibility: appConfig.volunteerEligibility });
        context.commit('updateSegEligibility', { segEligibility: appConfig.segEligibility });
        context.commit('updateFamilyEligibilityAllowed', appConfig.familyEligibilityAllowed );
        context.commit('updateRequireIDBackImage', appConfig.requireIDBackImage );
        context.commit('updateRequireIDFrontImage', appConfig.requireIDFrontImage );
        
        var foundationEligibility = appConfig.foundationEligibility;
        if(foundationEligibility) {
          context.commit('updateDonationEligibility', { donationEligibility: foundationEligibility.coreId });
          context.commit('updateDonationFoundation', { donationFoundation: foundationEligibility.name });
          context.commit('updateDonationFoundationUrl', foundationEligibility.foundationUrl );
          context.commit('updateDonationAmount', { donationAmount: foundationEligibility.donationAmount });
        }

        context.commit('updateApplicantEligibilityRequirement', appConfig.applicantEligibilityRequirement);
        context.commit('updateApplicationEligibilityRequirement', appConfig.applicationEligibilityRequirement);
        context.commit('updateIpCheckRequired', appConfig.ipCheckRequired);
        context.commit('updateIpDistanceCheckRequired', appConfig.ipDistanceCheckRequired);
        context.commit('updateBlockListCheckRequired', appConfig.blockListCheckRequired);
        context.commit('updateAddressStateCheckRequired', appConfig.addressStateCheckRequired);
        
        context.commit('updateChallengeQuestionsEnabled', appConfig.challengeQuestionEnabled);
        context.commit('updateChallengeQuestionsRequired', appConfig.challengeQuestionRequired);
        context.commit('updateChallengeQuestionsRetryAttempts', appConfig.challengeQuestionRetryAttempts);
        context.commit('updateAccountCategories', appConfig.accountCategories);

        return appConfig;
      } else {
        console.error('error in get application configuration', response.errorMessage);
      }  
      return null;
    },
    async getPortalContent (context) {
      let response = await api.getPortalContent();
      if(response.success) {
        var content = response.content;
        context.commit('updatePortalContent', { portalContent: content });
        return true;
      } else {
        console.error('error in get portal content', response.errorMessage);
      }  
      return false;
    },
    async parseIdentificationBack(context, { imageData } ) {      
      await context.commit('setParsingIdentification', true);
      let response = await api.parseDriversLicense(imageData);
      if(response.success) {
        var parsedDriversLicense = response;
        await context.commit('setParsingIdentification', false);
        return parsedDriversLicense;
      } else {
        console.error('error in parse identification', response.errorMessage);
        return {};
      }
    },
    async getSegCompanies(context) { 
      await context.commit('setRetrievingSegCompanies', true);
      let response = await api.getSegCompanies();
      if(response.success) {
        var segCompanies = response.companies;
        context.commit('updateSegCompanies', { segCompanies: segCompanies });
        await context.commit('setRetrievingSegCompanies', false);
        return segCompanies;
      } else {
        console.error('error in get seg companies', response.errorMessage);
        return {};
      }
    },
    async getIncomeTypes(context) {
      let response = await api.getIncomeTypes();
      if(response.success) {
        var incomeTypes = response.incomeTypes;
        return incomeTypes;
      } else {
        console.error('error in get application contents', response.errorMessage);
        return [];
      }
    },
    async verifyEligibility (context, { address1, city, state, zipCode, isResidence, isEmployment, isSchool, isVolunteer, isWorship }) {
      let response  = await api.verifyEligibility(address1, city, state, zipCode, isResidence, isEmployment, isSchool, isVolunteer, isWorship);
      if(response.success) {
        return response;
      } else {
        console.error('error in verify application eligibility', response.errorMessage);
        return false;
      }
    },
    async ipallowedCheck (context) {
      let response  = await api.validateIpAllowed();
      if(response.success) {                
        return response.isValidIp;
      } else {
        console.error('error in address check', response.errorMessage);
        return false;
      }
    },
    async blocklistCheck (context, { email, phone, ssn }) {
      let response  = await api.blocklistCheck(email, phone, ssn);
      if(response.success) {                
        return response.isAllowed;
      } else {
        console.error('error in blocklist check', response.errorMessage);
        return false;
      }
    },
    async ipDistanceCheck (context, { address1, city, state, zipCode }) {
      let response  = await api.validateIpDistance(address1, city, state, zipCode);
      if(response.success) {                
        return response.isValid;
      } else {
        console.error('error in ip distance check', response.errorMessage);
        return false;
      }
    },
    async addressCheck (context, { address1, city, state, zipCode }) {
      let response  = await api.addressCheck(address1, city, state, zipCode);
      if(response.success) {                
        return response.isValid;
      } else {
        console.error('error in address check', response.errorMessage);
        return false;
      }
    },
    async processApplication (context) {
      var application = {
        donationSelectedId: context.state.donationSelectedId,
        defaultId: '',
        accountTypeId: null,
        shareTypeIds: context.getters.shareTypeIds,
        services: null,
        funding: {
          fundsType: context.state.fundingOption.fundsType,
          fundAmount: context.getters.fundAmount,
          approvalCode: null,
          transactionNumber: null,
          creditCard: {
            cardNumber: null,
            cardType: null,
            cardSecurity: null,
            cardExpDate: null,
            cardName: null
          },
          finAccount: {
            accountType: null,
            routingNumber: null,
            accountNumber: null,
            institutionName: null
          }
        }
      }

      application.services = context.state.serviceIds;

      if(context.state.fundingOption.fundsType === 'ACH') {
        application.funding.finAccount = {
          accountType: context.state.fundingOption.accountType,
          routingNumber: context.state.fundingOption.routingNumber,
          accountNumber: context.state.fundingOption.accountNumber,
        }
      }

      // primary applicant info
      application.primaryEligibilityId = context.state.primaryEligibilityId;
      application.primaryApplicant = context.state.primaryApplicant;
      application.primaryApplicant.taxId = application.primaryApplicant.taxId.replace("-", "");
      application.primaryPhone = context.state.primaryPhone;
      application.primaryEmail = context.state.primaryEmail;
      application.primaryIdentification = context.state.primaryIdentification;
      application.primaryAddresses = context.getters.primaryAddresses;

      if(context.state.primaryMailingAddress.separateMailingAddress) {
        application.primaryMailingAddress = context.state.primaryMailingAddress;
      }

      if(context.state.primaryApplicant.isEmployed == true) {
        application.primaryEmployments = context.getters.primaryEmployments;
        if(context.state.primaryAdditionalIncomeSources.length > 0) {
          application.primaryAdditionalIncomes = context.state.primaryAdditionalIncomeSources;
        }
      }

      if(context.state.familyEligibilityAllowed  && context.state.primaryApplicant.familyEligibility == true) {        
        application.primaryFamilyEligibility = {};      
        application.primaryFamilyEligibility.name = context.state.primaryFamilyMember.name;      
        application.primaryFamilyEligibility.relationship = context.state.primaryFamilyMember.relationship;   
      }

      // joint applicant info
      if(context.state.isJointApplication == true) {
        application.jointEligibilityId = context.state.jointEligibilityId;
        application.jointApplicant = context.state.jointApplicant;
        application.jointApplicant.taxId = application.jointApplicant.taxId.replace("-", "");        
        application.jointPhone = context.state.jointPhone;
        application.jointEmail = context.state.jointEmail;
        application.jointIdentification = context.state.jointIdentification;
        application.jointAddresses = context.getters.jointAddresses;

        if(context.state.jointMailingAddress.separateMailingAddress) {
          application.jointMailingAddress = context.state.jointMailingAddress;
        }
        
        if(context.state.jointApplicant.isEmployed == true) {
          application.jointEmployments = context.getters.jointEmployments;          
          if(context.state.jointAdditionalIncomeSources.length > 0) {
            application.jointAdditionalIncomes = context.state.jointAdditionalIncomeSources;
          }
        }

        if(context.state.familyEligibilityAllowed  && context.state.jointApplicant.familyEligibility == true) {        
          application.jointFamilyEligibility = {};      
          application.jointFamilyEligibility.name = context.state.jointFamilyMember.name;      
          application.jointFamilyEligibility.relationship = context.state.jointFamilyMember.relationship;   
        }
      }

      console.info(">> sending application", application);
      let response  = await api.processApplication(application);
      console.info(">> response received", response);
      return response;
    },
    async sendEsignAgreement (context, emailAddress) {
      let response  = await api.sendEsignAgreement(emailAddress);
      if(response.success) {
        return true;
      } else {
        console.error('error in send esign agreement', response.errorMessage);
        return false;
      }
    },
    async getChallengeQuestions (context, { isPrimary }) {
      var person = context.state.primaryApplicant;
      var address = context.state.primaryAddress;
      if(isPrimary === false) {
        person = context.state.jointApplicant;
        address = context.state.jointAddress;
      }
      let response  = await api.getChallengeQuestions(person, address);
      if(response.success) {
        await context.commit('updateApplicantChallengeId', { isPrimary: isPrimary, challengeId: response.id });        
        return response;
      } else {
        console.error('error in get challenge questions', response.errorMessage);
        return false;
      }
    },
    async answerChallengeQuestions (context, { isPrimary, questions, quizId, tranId }) {
      let response  = await api.answerChallengeQuestions(questions, quizId, tranId);
      if(response.success) {
        await context.commit('updateApplicantChallengeScore', { isPrimary: isPrimary, score: response.challengeScore });        
        return true;
      } else {
        console.error('error in answer challenge questions', response.errorMessage);
        await context.commit('updateApplicantChallengeScore', { isPrimary: isPrimary, score: response.challengeScore });        
        return false;
      }
    },
    async sendMfaLink (context) {
      let response  = await api.sendMfaLink(context.state.identityVerification);
      if(response.success) {
        return response;
      } else {
        console.error('error in send mfa link', response.errorMessage);
        return false;
      }
    },
    async sendPasscode (context) {
      let response  = await api.sendPasscode(context.state.identityVerification);
      if(response.success) {
        return response;
      } else {
        console.error('error in send passcode', response.errorMessage);
        return false;
      }
    },
    async verifyMfaLink (context) {
      let response  = await api.verifyMfaLink(context.state.identityVerification);
      if(response.success) {
        return response;
      } else {
        console.error('error in verify mfa link', response.errorMessage);
        return false;
      }
    },
    async verifyPasscode (context) {
      let response  = await api.verifyPasscode(context.state.identityVerification);
      if(response.success) {
        return response;
      } else {
        console.error('error in verify passcode', response.errorMessage);
        return false;
      }
    },
    async getVerifiedPerson (context) {
      let response  = await api.getVerifiedPerson(context.state.identityVerification);
      if(response.success) {
        return response;
      } else {
        console.error('error in get vefiried person', response.errorMessage);
        return false;
      }
    },
    updatePrimaryPerson: async(context, { person }) => {
      await console.info('updating primary person with', person);
      await context.commit('updateApplicantFirstName', { isPrimary: true, firstName: person.firstName });
      await context.commit('updateApplicantLastName', { isPrimary: true, lastName: person.lastName });
      await context.commit('updateApplicantDateOfBirth', { isPrimary: true, dateOfBirth: new Date(person.birthDate) });
      await context.commit('updateApplicantTaxId', { isPrimary: true, taxId: person.tin });
      await context.commit('updateApplicantAddress1', { isPrimary: true, isCurrentAddress: true, address1: person.street });
      await context.commit('updateApplicantCity', { isPrimary: true, isCurrentAddress: true, city: person.city });
      await context.commit('updateApplicantState', { isPrimary: true, isCurrentAddress: true, state: person.state });
      await context.commit('updateApplicantZipCode', { isPrimary: true, isCurrentAddress: true, zipCode: person.zipCode });
      await  context.commit('updateApplicantPhone', { isPrimary: true, phoneNumber: person.phoneNumber });
      await  context.commit('updatePhoneType', { isPrimary: true, phoneType: 'Personal Cell' });
      await context.commit('updatePhoneTypeText', { isPrimary: true, phoneTypeText: 'Cell' });
      console.info('updating primary person with', context.state.primaryApplicant);
    },
  }
})